export default __webpack_public_path__ + "static/media/loginBCMob2.e64244ba.png";